import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div className="relative min-h-screen bg-cover bg-center" style={{ backgroundImage: "url('/assets/language-bg.jpg')" }}>

      <Helmet>
        <title>Home - PairLingo</title>
        <meta name="description" content="Chat with perfect language partner on PairLingo." />
        <meta name="keywords" content="language learning, pairlingo, chat, match, speaking chat, german language partner chat" />
      </Helmet>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60 h-full max-h-[730px]" />

      <main className="min-h-[calc(100vh-64px)] flex flex-col justify-between">

        {/* Hero content */}
        <div className="relative z-10 flex flex-col items-center justify-center text-white text-center px-4 py-40 sm:py-56">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 drop-shadow-lg">
            Find Your Language Partner Instantly
          </h1>
          <p className="text-lg sm:text-xl max-w-xl mb-6 drop-shadow">
            PairLingo connects you with real learners at your level — no tutors, no pressure, totally free.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/user-preview" className="bg-indigo-600 hover:bg-indigo-500 px-6 py-3 rounded text-white font-semibold text-lg shadow">
              Get Started
            </Link>
            <a href="#how-it-works" className="border border-white px-6 py-3 rounded text-white font-semibold text-lg shadow">
              How It Works
            </a>
          </div>
        </div>

        <section id="how-it-works" className="bg-white py-16 px-4 sm:px-8 lg:px-16 mt-20">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-indigo-700 mb-10">
              How PairLingo Works
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left">
              {[
                {
                  icon: "🌐",
                  title: "Pick Language & Level",
                  desc: "Choose the language you want to practice and your proficiency level.",
                },
                {
                  icon: "🤝",
                  title: "Get Matched",
                  desc: "Browse learners at your level and send a request to connect.",
                },
                {
                  icon: "💬",
                  title: "Chat Instantly",
                  desc: "Once accepted, chat in real-time and start planning your sessions.",
                },
                {
                  icon: "📅",
                  title: "Schedule & Meet",
                  desc: "Pick a date, share a link (Zoom/Meet/Teams), and start practicing!",
                },
              ].map((step, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-xl shadow hover:shadow-md transition duration-300">
                  <div className="text-4xl mb-4">{step.icon}</div>
                  <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
                  <p className="text-gray-600 text-sm">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-indigo-50 py-16 px-4 sm:px-8 lg:px-16 mt">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-indigo-700 mb-10">
              Why Choose PairLingo?
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left">
              {[
                {
                  icon: "💸",
                  title: "Totally Free",
                  desc: "No subscription, no hidden fees. Just real language practice with real learners.",
                },
                {
                  icon: "👥",
                  title: "Peer Matching",
                  desc: "Connect with learners at your level — not tutors or professionals.",
                },
                {
                  icon: "🔒",
                  title: "Safe & Private",
                  desc: "No public profile, no unnecessary info. You control your visibility.",
                },
                {
                  icon: "💬",
                  title: "Built-in Chat + Scheduling",
                  desc: "Real-time chat, calendar scheduling, and link sharing — all in one place.",
                },
              ].map((benefit, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow hover:shadow-md transition duration-300">
                  <div className="text-4xl mb-4">{benefit.icon}</div>
                  <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
                  <p className="text-gray-600 text-sm">{benefit.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-indigo-600 py-16 text-white text-center px-4 sm:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Start Practicing?</h2>
          <p className="text-lg mb-6">Find someone at your level and start speaking today — no pressure, totally free.</p>
          <a
            href="/users"
            className="inline-block bg-white text-indigo-600 font-semibold px-6 py-3 rounded shadow hover:bg-gray-100 transition"
          >
            🔍 Find Your Partner Now
          </a>
        </section>

      </main>

    </div>
  );
};

export default Home;